import styled from 'styled-components';

export const Wrapper = styled.div<{ isLoading?: boolean; grayscale: string; blur: string }>`
    pointer-events: ${(props) => (props.isLoading ? 'none' : 'revert')};
    cursor: ${(props) => (props.isLoading ? 'not-allowed' : 'revert')};
    filter: ${(props) => (props.isLoading ? `grayscale(${props.grayscale}) blur(${props.blur})` : 'revert')};
    user-select: ${(props) => (props.isLoading ? 'none' : 'revert')};
`;
